import { isAbortError, isBenignExternalScript } from './abortError';

const SKIP_PATTERNS = [
  /النافذة الزمنية للتحديث/,
  /الرجاء الانتظار \d+ ثانية قبل التحديث/,
  /يجب الانتظار \d+ ثانية بين التحديثات/,
  /The user aborted a request/i,
  /AbortError/i,
];

export default async function logError(message, stack = '', extraUrl = '') {
  try {
    const text = typeof message === 'string' ? message : String(message);
    if (isAbortError(message) || isBenignExternalScript(extraUrl, stack)) return;
    if (SKIP_PATTERNS.some((re) => re.test(text))) return;

    const url = extraUrl || window.location.href;
    const payload = {
      url: url.substring(0, 1000),
      message: typeof message === 'string' ? message.substring(0, 2000) : String(message).substring(0, 2000),
      stack: stack ? stack.substring(0, 5000) : '',
      userAgent: navigator.userAgent.substring(0, 500),
    };
    const token = localStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = 'Bearer ' + token;
    await fetch('/api/client/log-error', {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    });
  } catch {
    // Never throw from error logging
  }
}
